
























import Element from '../../../mixins/element';
import CardType from '../../../components/CardType.vue';
import { Component } from 'vue-property-decorator';
import { hardCodeBrand } from '../../../../services';

@Component({
    components: {
        CardType,
    },
})
export default class CreditCard extends Element {
    public cardNumber: any;
    public toMount() {
        this.loading = true;
        this.cardNumber = this.integrationData.elements.create('cardNumber', {
            style: this.integrationStyles.styles,
            classes: this.integrationStyles.classes,
            placeholder: '**** **** **** ****',
        });

        const id = (this.$el.id || 'str1_') + Math.round(Math.random() * 10000);
        (this.$refs.input as HTMLElement).id = id;
        this.cardNumber.mount(`#${id}`);

        this.cardNumber.on('ready', () => {
            this.loading = false;
        });

        this.cardNumber.on('focus', () => {
            this.onFocus();
        });

        this.cardNumber.on('blur', () => {
            this.onBlur();
        });

        this.cardNumber.on('change', (data: any) => {
            if (data.brand === 'unknown') {
                data.brand = null;
            }
            data.brand = hardCodeBrand(data.brand);
            const result: any = {
                ...data,
                isEmpty: data.empty,
            };
            delete result.empty;
            this.input = result;
        });
    }

    public toValidate(): boolean {
        return this.serializedData.complete || false;
    }

    public toClear() {
        this.cardNumber.clear('cardCvc');
    }

    public toDestroy() {
        this.cardNumber.destroy();
    }

    public toFocus(): void {
        this.cardNumber.focus();
    }

    public toBlur(): void {
        this.cardNumber.blur();
    }
}
